import { API } from 'api';
import { useMutation } from 'react-query';

export interface IAgentBulkImportUpload {
  payload: {
    eid?: string;
    file?: File;
    type?: string;
  };
}

const agentBulkImportUpload = (payload: IAgentBulkImportUpload['payload']) => {
  const formData = new FormData();
  formData.append('eid', payload.eid ?? '');
  formData.append('fileData', payload.file ?? '');
  formData.append('type', payload.type ?? '');
  // bulk import is processed synchronously and can exceed the default 30s timeout;
  // a timed-out request still completes on the server, so retrying creates duplicate entries
  return API.post()(
    '/api/employer/bulkUpdate/comission/create',
    formData,
    {
      'Content-Type': 'multipart/form-data',
    },
    120000
  );
};

export const useAgentBulkImportUpload = () => {
  return useMutation(agentBulkImportUpload, {
    onSuccess: (response) => {
      return response.data;
    },
  });
};
